import { axiosInstance } from '@/plugins/axios';

const aciton = {
  password: { // 密码相关
    oldPwd: 'candao.user.oldPwdAlterPwd', // 旧密码修改密码
    phone: 'candao.user.phoneVerficAlterPasswd', // 手机验证码修改密码
    email: 'candao.user.emailVerficAlterPasswd', // 邮件验证码修改密码
  },
  user: { // 用户相关
    info: 'candao.user.getBaseInfo', // 获取用户数据
    update: 'candao.user.completeUserInfo', // 完善用户信息
    phoneBind: 'candao.user.phoneBind', // 绑定手机
  },
  login: { // 登录相关
    passwd: 'candao.user.passwdLogin', // 用户名账号登录
    out: 'candao.user.logout', // 退出登录
  },
  address: { // 地址相关
    getter: 'candao.userAddress.getList', // 获取用户地址
    delete: 'candao.userAddress.delete', // 删除用户地址
    add: 'candao.userAddress.add', // 新增用户地址
    update: 'candao.userAddress.update', // 更新用户地址
  },
  register: 'candao.user.phoneRegist', // 用户注册
  score: 'candao.member.getMemberScore', // 获取用户积分
  affiliate: 'candao.user.affiliateAdd', // 申请加入
  getCustomizedWebSettingByKeyId: 'candao.storeOwn.getCustomizedWebSettingByKeyId', // 根据keyid获取定制版web配置
};

class User {
  time = ''; // 登录时间

  info = {}; // 用户数据
  // limit = 5 * 60 * 60 * 1000; // 用户登录过期时间

  third = {}; // 第三方会员数据

  is = false; // 是否登录

  constructor(time = '', info = {}) {
    this.time = time;
    this.info = info;
  }

  clear = () => { // 清除用户数据
    this.time = '';
    this.info = {};
    this.third = {};
    this.is = false;
  }

  login = (time = '', info = null, third = {}) => {
    if (!info) {
      // 没用用户信息则失败
      this.clear();
      return;
    }
    this.time = time;
    this.info = info;
    this.third = third;
    this.is = true;
  }

  check = () => Boolean(Object.keys(this.info).length && this.time && Object.keys(this.third).length)

  update = (info, time = new Date().getTime(), third) => { // 更新用户
    this.time = time;
    this.info = info;
    this.third = third;
    this.is = true;
  }
}

const user = new User(); // 实例化user对象

const getUser = () => user;

// 公用请求方法
const common = ({ actionName, method = 'mothod', ...data }) => axiosInstance({
  method: 'post',
  url: 'Action',
  params: {
    method,
  },
  data: {
    actionName,
    ...data,
  },
});

/* 用户接口模块 */

// 第三方会员接口，目前是雪沥
// http://api.can-dao.com:9999/showdoc/web/#/3?page_id=1104
const third = {
  // 查询会员接口
  query: data => axiosInstance({
    method: 'post',
    url: 'UserXueLi',
    params: {
      method: 'findUser',
      serviceId: 4,
      actionId: 1,
    },
    data,
  }),
};


// 获取用户数据
const getUserInfo = () => axiosInstance({
  method: 'post',
  url: 'SecretAction',
  params: {
    method: 'getBaseInfo',
  },
  data: {
    actionName: aciton.user.info,
  },
})
  .then(res => third.query({ content: { mobile: res.data.phone } }).then(thirdData => [res, thirdData]))
  .then((arg) => {
    user.login(arg[0].serverTime, arg[0].data, arg[1].data);
    return arg;
  });

// 完善用户信息
const update = ({ actionName = aciton.user.update, ...data }) => axiosInstance({
  method: 'post',
  url: 'SecretAction',
  params: {
    method: 'completeUserInfo',
  },
  data: {
    actionName,
    ...data,
  },
});

// 判断用户是否登录
const isLogin = () => axiosInstance({
  method: 'post',
  url: 'LocalAction',
  params: {
    method: 'isLogin',
  },
  data: {
    actionName: 'isLogin',
  },
});

// 申请加入
const affiliateAdd = ({ actionName = aciton.affiliate, ...data }) => axiosInstance({
  method: 'post',
  url: 'Action',
  params: {
    method: 'affiliateAdd',
  },
  data: {
    actionName,
    // actionName: 'candao.user.affiliateAdd',
    ...data,
  },
});

const getCustomizedWebSettingByKeyId = ({ actionName = aciton.getCustomizedWebSettingByKeyId, ...data }) => axiosInstance({
  method: 'post',
  url: 'Action',
  params: {
    method: 'affiliateAdd',
  },
  data: {
    actionName,
    content: {
      ...data,
    },
  },
});

// 登录相关
const login = {
  // 用户名账号登录
  account: ({ actionName = aciton.login.passwd, ...data }) => axiosInstance({
    method: 'post',
    url: 'Action',
    params: {
      method: 'login',
    },
    data: {
      actionName,
      ...data,
    },
  }).then((res) => {
    sessionStorage.clear();
    return res;
  }),
  // 退出登录
  out: ({ actionName = aciton.login.out, ...data }) => axiosInstance({
    method: 'post',
    url: 'Action',
    params: {
      method: 'logout',
    },
    data: {
      actionName,
      ...data,
    },
  }).then((res) => {
    sessionStorage.clear();
    return res;
  }),
};

// 用户修改密码相关
const password = {
  // phoneVerficAlterPasswd: {actionName: 'candao.user.phoneVerficAlterPasswd'}, // 手机验证码修改密码
  // emailVerficAlterPasswd: {actionName: 'candao.user.emailVerficAlterPasswd'}, // 邮件验证码修改密码
  oldPwd: ({ actionName = aciton.password.oldPwd, ...data }) => axiosInstance({
    method: 'post',
    url: 'SecretAction',
    data: {
      actionName,
      ...data,
    },
  }),
  phone: ({ actionName = aciton.password.phone, ...data }) => axiosInstance({
    method: 'post',
    url: 'Action',
    data: {
      actionName,
      ...data,
    },
  }),
  email: ({ actionName = aciton.password.email, ...data }) => axiosInstance({
    method: 'post',
    url: 'SecretAction',
    data: {
      actionName,
      ...data,
    },
  }),
};

// 地址接口相关
const address = {
  // 获取用户地址
  getter: ({ actionName = aciton.address.getter, ...data }) => axiosInstance({
    method: 'post',
    url: 'SecretAction',
    params: {
      method: 'getAddressList',
    },
    data: {
      actionName,
      ...data,
    },
  }),
  // 删除用户地址
  delete: ({ actionName = aciton.address.delete, ...data }) => axiosInstance({
    method: 'post',
    url: 'SecretAction',
    data: {
      actionName,
      ...data,
    },
  }),
  add: ({ actionName = aciton.address.add, ...data }) => common({ actionName, method: actionName.split('.')[2], ...data }),
};

// 获取用户积分
const score = ({ actionName = aciton.score, ...data }) => axiosInstance({
  method: 'post',
  url: 'SecretAction',
  data: {
    actionName,
    ...data,
  },
});

// 注册用户
// {actionName: 'candao.user.phoneRegist'}, // 手机注册
// {actionName: 'candao.user.mailRegist'}, // 邮箱注册
const register = ({ actionName = aciton.register, ...data }) => axiosInstance({
  method: 'post',
  url: 'Action',
  data: {
    actionName,
    ...data,
  },
})
  .then(res => third.query({ secretKey: res.secretKey })); // 注册成功，然后用secretKey去登录雪沥会员

// 绑定手机
const phoneBind = ({ actionName = aciton.user.phoneBind, ...data }) => axiosInstance({
  method: 'post',
  url: 'Action',
  data: {
    actionName,
    ...data,
  },
});

export default {
  // third,
  getUserInfo,
  isLogin,
  login,
  getUser,
  register,
  address,
  password,
  score,
  update,
  affiliateAdd,
  phoneBind,
  getCustomizedWebSettingByKeyId,
};

export {
  isLogin,
};
